import styled from 'styled-components'

export const RanksGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 20px;
  padding: 0 10px;

  @media (max-width: 1024px) {
    grid-template-columns: 1fr;
  }
`

export const TableWrapper = styled.div`
  background: ${(props) =>
    props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 0, 0, 0.25)'};
  border-radius: 12px;
  padding: 20px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};
  box-shadow: ${(props) =>
    props.theme.name === 'light'
      ? '0 4px 16px rgba(0, 0, 0, 0.06)'
      : '0 4px 20px rgba(0, 0, 0, 0.25)'};
  backdrop-filter: blur(8px);
`

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: ${(props) =>
    props.theme.name === 'light' ? '#0f172a' : '#fff'};
  font-size: 13px;

  thead tr {
    background: ${(props) =>
      props.theme.name === 'light'
        ? '#f8fafc'
        : 'rgba(255, 255, 255, 0.06)'};
  }

  th {
    padding: 12px 14px;
    text-align: left;
    font-weight: 600;
    color: ${(props) =>
      props.theme.name === 'light' ? '#334155' : '#e2e8f0'};
    border-bottom: 2px solid
      ${(props) =>
        props.theme.name === 'light' ? '#0284c7' : 'rgba(166, 193, 11, 0.4)'};
    font-size: 12px;
    letter-spacing: 0.5px;
    white-space: nowrap;
  }

  td {
    padding: 11px 14px;
    border-bottom: 1px solid
      ${(props) =>
        props.theme.name === 'light'
          ? '#f1f5f9'
          : 'rgba(255, 255, 255, 0.05)'};
    white-space: nowrap;
  }

  tbody tr {
    transition: background 0.15s ease;
  }

  tbody tr:hover {
    background: ${(props) =>
      props.theme.name === 'light'
        ? '#f8fafc'
        : 'rgba(166, 193, 11, 0.08)'};
  }
`

export const Badge = styled.div`
  background: ${(props) =>
    props.theme.name === 'light' ? '#f8fafc' : 'rgba(166, 193, 11, 0.15)'};
  border: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : '#a6c10b')};
  border-radius: 10px;
  padding: 10px 18px;
  color: ${(props) => (props.theme.name === 'light' ? '#0284c7' : '#a6c10b')} !important;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  p, span {
    color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#ffffff')} !important;
  }
`

export const PositionBadge = styled.span<{ bgColor: string; textColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.textColor};
  font-weight: 700;
  font-size: 12px;
`

export const DiasCoberturaCell = styled.span<{ color: string }>`
  color: ${(props) => props.color};
  font-weight: 700;
  font-size: 14px;
`

export const LegendaContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  margin-bottom: 20px;
  padding: 0 10px;
  flex-wrap: wrap;
`

export const LegendaItem = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
  align-items: center;
  font-size: 12px;
  color: ${(props) =>
    props.theme.name === 'light' ? '#475569' : 'rgba(255, 255, 255, 0.7)'};
`

export const LegendaDot = styled.span<{ bgColor: string }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${(props) => props.bgColor};
`

// --- NOVOS COMPONENTES ANALÍTICOS DE ALTO PADRÃO ---

export const CoverageHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 16px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const TitleSection = styled.div`
  border-left: 4px solid #a6c10b;
  padding-left: 14px;

  h2 {
    font-size: 22px;
    font-weight: 700;
    color: ${(props) => props.theme.titleColor};
    margin: 0;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  p {
    font-size: 12px;
    color: ${(props) => props.theme.subtitleColor};
    margin: 4px 0 0 0;
  }
`

export const ActionsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

export const TabsContainer = styled.div`
  display: flex;
  background: ${(props) =>
    props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 24, 66, 0.6)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.1)'};
  border-radius: 10px;
  padding: 4px;
  gap: 6px;
  margin: 0 10px 24px 10px;
  box-shadow: ${(props) =>
    props.theme.name === 'light' ? '0 2px 8px rgba(0,0,0,0.04)' : 'none'};
  backdrop-filter: blur(10px);

  @media (max-width: 768px) {
    flex-direction: column;
    margin: 0 0 20px 0;
  }
`

export const TabButton = styled.button<{ $active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: ${(props) =>
    props.$active
      ? props.theme.name === 'light'
        ? 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)'
        : 'linear-gradient(135deg, #a6c10b 0%, #859d09 100%)'
      : 'transparent'};
  color: ${(props) =>
    props.$active
      ? '#ffffff'
      : props.theme.name === 'light'
      ? '#475569'
      : '#cbd5e1'};
  border: none;
  padding: 10px 22px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: ${(props) => (props.$active ? '700' : '500')};
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: ${(props) =>
    props.$active
      ? props.theme.name === 'light'
        ? '0 2px 10px rgba(2, 132, 199, 0.3)'
        : '0 2px 10px rgba(166, 193, 11, 0.35)'
      : 'none'};

  &:hover {
    color: ${(props) =>
      props.$active
        ? '#ffffff'
        : props.theme.name === 'light'
        ? '#0f172a'
        : '#ffffff'};
    background: ${(props) =>
      props.$active
        ? props.theme.name === 'light'
          ? 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)'
          : 'linear-gradient(135deg, #b8d415 0%, #859d09 100%)'
        : props.theme.name === 'light'
        ? '#f1f5f9'
        : 'rgba(255, 255, 255, 0.06)'};
  }

  svg {
    font-size: 16px;
  }
`

export const KpiGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
  gap: 16px;
  padding: 0 10px;
  margin-bottom: 24px;
`

export const KpiCard = styled.div<{ $borderColor?: string }>`
  background: ${(props) =>
    props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 24, 66, 0.55)'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light'
        ? '#cbd5e1'
        : props.$borderColor || 'rgba(255, 255, 255, 0.12)'};
  border-left: 4px solid
    ${(props) =>
      props.$borderColor ||
      (props.theme.name === 'light' ? '#0284c7' : '#a6c10b')};
  border-radius: 12px;
  padding: 16px 18px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${(props) =>
    props.theme.name === 'light'
      ? '0 4px 16px rgba(0, 0, 0, 0.05)'
      : '0 4px 15px rgba(0, 0, 0, 0.3)'};
  backdrop-filter: blur(8px);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#ffffff')} !important;

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${(props) =>
      props.theme.name === 'light'
        ? '0 6px 20px rgba(0, 0, 0, 0.08)'
        : '0 6px 20px rgba(0, 0, 0, 0.4)'};
  }

  .kpi-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${(props) => (props.theme.name === 'light' ? '#475569' : '#cbd5e1')} !important;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;

    span, .kpi-title {
      color: ${(props) => (props.theme.name === 'light' ? '#475569' : '#cbd5e1')} !important;
      font-weight: 600;
    }

    svg {
      font-size: 18px;
      color: ${(props) =>
        props.$borderColor ||
        (props.theme.name === 'light' ? '#0284c7' : '#a6c10b')} !important;
      flex-shrink: 0;
    }
  }

  .kpi-value {
    font-size: 24px;
    font-weight: 700;
    color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#ffffff')} !important;
    letter-spacing: -0.5px;
    margin-bottom: 6px;
  }

  .kpi-footer, .kpi-subtitle {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: ${(props) => (props.theme.name === 'light' ? '#64748b' : '#94a3b8')} !important;
    line-height: 1.4;

    span {
      color: ${(props) => (props.theme.name === 'light' ? '#64748b' : '#94a3b8')} !important;
    }
  }
`

export const TrendBadge = styled.span<{ $type: 'positive' | 'negative' | 'neutral' }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 7px;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  background: ${(props) =>
    props.$type === 'positive'
      ? 'rgba(34, 197, 94, 0.15)'
      : props.$type === 'negative'
      ? 'rgba(239, 68, 68, 0.15)'
      : props.theme.name === 'light'
      ? 'rgba(100, 116, 139, 0.12)'
      : 'rgba(148, 163, 184, 0.15)'};
  color: ${(props) =>
    props.$type === 'positive'
      ? props.theme.name === 'light' ? '#15803d' : '#22c55e'
      : props.$type === 'negative'
      ? '#ef4444'
      : props.theme.name === 'light' ? '#475569' : '#94a3b8'};
  border: 1px solid
    ${(props) =>
      props.$type === 'positive'
        ? 'rgba(34, 197, 94, 0.3)'
        : props.$type === 'negative'
        ? 'rgba(239, 68, 68, 0.3)'
        : props.theme.name === 'light'
        ? 'rgba(100, 116, 139, 0.25)'
        : 'rgba(148, 163, 184, 0.3)'};
`

export const ChartCard = styled.div`
  background: ${(props) =>
    props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 0, 0, 0.25)'};
  border-radius: 12px;
  padding: 20px;
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.08)'};
  margin: 0 10px 24px 10px;
  box-shadow: ${(props) =>
    props.theme.name === 'light'
      ? '0 4px 16px rgba(0, 0, 0, 0.05)'
      : '0 4px 20px rgba(0, 0, 0, 0.25)'};
`

export const ChartCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => (props.theme.name === 'light' ? '#0284c7' : '#a6c10b')};
    display: flex;
    align-items: center;
    gap: 8px;
  }

  span.chart-subtitle {
    font-size: 12px;
    color: ${(props) => (props.theme.name === 'light' ? '#64748b' : '#94a3b8')};
  }
`

export const TableControls = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`

export const SearchInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 240px;

  svg {
    position: absolute;
    left: 12px;
    color: #94a3b8;
    font-size: 14px;
  }

  input {
    width: 100%;
    background: ${(props) => (props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 24, 66, 0.6)')};
    border: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : 'rgba(255, 255, 255, 0.12)')};
    border-radius: 8px;
    padding: 8px 12px 8px 34px;
    color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#fff')};
    font-size: 13px;
    outline: none;
    transition: border-color 0.2s;

    &:focus {
      border-color: ${(props) => (props.theme.name === 'light' ? '#0284c7' : '#a6c10b')};
    }

    &::placeholder {
      color: ${(props) => (props.theme.name === 'light' ? '#94a3b8' : '#64748b')};
    }
  }
`

export const ExportButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: rgba(34, 197, 94, 0.15);
  border: 1px solid #22c55e;
  color: #22c55e;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #22c55e;
    color: #052e16;
  }

  svg {
    font-size: 14px;
  }
`

export const StatusBadge = styled.span<{ $status: 'Ativo' | 'Sem Cobertura' }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  background: ${(props) =>
    props.$status === 'Ativo'
      ? 'rgba(34, 197, 94, 0.15)'
      : 'rgba(148, 163, 184, 0.15)'};
  color: ${(props) => (props.$status === 'Ativo' ? '#22c55e' : '#94a3b8')};
  border: 1px solid
    ${(props) =>
      props.$status === 'Ativo'
        ? 'rgba(34, 197, 94, 0.3)'
        : 'rgba(148, 163, 184, 0.25)'};
`

export const TableScroll = styled.div`
  overflow-x: auto;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.08);

  &::-webkit-scrollbar {
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #a6c10b;
    border-radius: 3px;
  }
`

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 4px 4px 4px;
  margin-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  flex-wrap: wrap;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const PaginationInfo = styled.span`
  color: #94a3b8;
  font-size: 12px;

  b {
    color: #e2e8f0;
  }
`

export const PaginationControls = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const PageButton = styled.button<{ $active?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: ${(props) => (props.$active ? '700' : '500')};
  background: ${(props) =>
    props.$active ? '#a6c10b' : 'rgba(255, 255, 255, 0.06)'};
  color: ${(props) => (props.$active ? '#091c3e' : '#cbd5e1')};
  border: 1px solid
    ${(props) =>
      props.$active ? '#a6c10b' : 'rgba(255, 255, 255, 0.1)'};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background: ${(props) => (props.$active ? '#b8d415' : 'rgba(255, 255, 255, 0.12)')};
    color: ${(props) => (props.$active ? '#091c3e' : '#ffffff')};
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
  }
`

export const PageSizeSelect = styled.select`
  background: rgba(0, 24, 66, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.12);
  color: #e2e8f0;
  font-size: 12px;
  padding: 6px 10px;
  border-radius: 6px;
  outline: none;
  cursor: pointer;

  option {
    background: #091c3e;
    color: #fff;
  }
`

export const ProgressBarTrack = styled.div`
  width: 90px;
  height: 6px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 3px;
  overflow: hidden;
  display: inline-block;
  vertical-align: middle;
  margin-right: 8px;
`

export const ProgressBarFill = styled.div<{ $percent: number; $color?: string }>`
  height: 100%;
  width: ${(props) => Math.min(100, Math.max(0, props.$percent))}%;
  background: ${(props) => props.$color || '#a6c10b'};
  border-radius: 3px;
  transition: width 0.3s ease;
`

export const SelectedDistributorCard = styled.div`
  background: linear-gradient(135deg, rgba(8, 38, 99, 0.75) 0%, rgba(3, 16, 46, 0.85) 100%);
  border: 1px solid rgba(166, 193, 11, 0.4);
  border-left: 5px solid #a6c10b;
  border-radius: 14px;
  padding: 20px 24px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35), 0 0 15px rgba(166, 193, 11, 0.1);
  backdrop-filter: blur(12px);
  animation: fadeIn 0.25s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-8px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .dist-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding-bottom: 14px;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .dist-info {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;

    h3 {
      margin: 0;
      font-size: 18px;
      font-weight: 700;
      color: #ffffff;
      display: flex;
      align-items: center;
      gap: 8px;
    }

    .badge-code {
      background: rgba(255, 255, 255, 0.1);
      color: #e2e8f0;
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 6px;
      font-weight: 600;
    }

    .badge-uf {
      background: rgba(166, 193, 11, 0.2);
      color: #a6c10b;
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 6px;
      font-weight: 700;
      border: 1px solid rgba(166, 193, 11, 0.4);
    }

    .badge-reg {
      background: rgba(56, 189, 248, 0.15);
      color: #38bdf8;
      font-size: 11px;
      padding: 3px 8px;
      border-radius: 6px;
      font-weight: 600;
    }
  }

  .dist-close-btn {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: #cbd5e1;
    border-radius: 6px;
    padding: 6px 12px;
    font-size: 12px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;

    &:hover {
      background: rgba(239, 68, 68, 0.2);
      border-color: rgba(239, 68, 68, 0.4);
      color: #ef4444;
    }
  }
`

export const FeaturedDistGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 14px;
`

export const FeaturedDistKpi = styled.div<{ $borderColor?: string }>`
  background: ${(props) => (props.theme.name === 'light' ? '#ffffff' : 'rgba(0, 0, 0, 0.3)')};
  border: 1px solid ${(props) => (props.theme.name === 'light' ? '#cbd5e1' : props.$borderColor || 'rgba(255, 255, 255, 0.08)')};
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: ${(props) => (props.theme.name === 'light' ? '0 2px 8px rgba(0,0,0,0.04)' : 'none')};
  color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#ffffff')};

  .featured-label {
    font-size: 11px;
    color: ${(props) => (props.theme.name === 'light' ? '#475569' : '#cbd5e1')};
    text-transform: uppercase;
    font-weight: 600;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    span {
      color: ${(props) => (props.theme.name === 'light' ? '#475569' : '#cbd5e1')};
    }

    svg {
      color: ${(props) => props.$borderColor || (props.theme.name === 'light' ? '#0284c7' : '#a6c10b')};
      font-size: 14px;
    }
  }

  .featured-val {
    font-size: 20px;
    font-weight: 700;
    color: ${(props) => (props.theme.name === 'light' ? '#0f172a' : '#ffffff')};
    letter-spacing: -0.3px;
    margin-bottom: 4px;
  }

  .featured-sub {
    font-size: 11px;
    color: ${(props) => (props.theme.name === 'light' ? '#64748b' : '#94a3b8')};

    span {
      color: ${(props) => (props.theme.name === 'light' ? '#64748b' : '#94a3b8')};
    }
  }
`

export const InvasionBadge = styled.span<{ $isWarning?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  background: ${(props) =>
    props.theme.name === 'light'
      ? props.$isWarning ? '#fee2e2' : '#fef3c7'
      : props.$isWarning ? 'rgba(239, 68, 68, 0.18)' : 'rgba(245, 158, 11, 0.15)'};
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.$isWarning ? '#b91c1c' : '#92400e'
      : props.$isWarning ? '#f87171' : '#fbbf24'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light'
        ? props.$isWarning ? '#fca5a5' : '#fcd34d'
        : props.$isWarning ? 'rgba(239, 68, 68, 0.35)' : 'rgba(245, 158, 11, 0.3)'};
  white-space: nowrap;
`

export const TerritoryAlertBox = styled.div<{ $severity: 'quebra' | 'invasao_pontual' }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border-radius: 8px;
  margin-bottom: 14px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) =>
    props.theme.name === 'light'
      ? props.$severity === 'quebra' ? '#fef2f2' : '#fffbeb'
      : props.$severity === 'quebra' ? 'rgba(239, 68, 68, 0.15)' : 'rgba(245, 158, 11, 0.12)'};
  color: ${(props) =>
    props.theme.name === 'light'
      ? props.$severity === 'quebra' ? '#991b1b' : '#92400e'
      : props.$severity === 'quebra' ? '#fca5a5' : '#fde68a'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'light'
        ? props.$severity === 'quebra' ? '#fecaca' : '#fde68a'
        : props.$severity === 'quebra' ? 'rgba(239, 68, 68, 0.4)' : 'rgba(245, 158, 11, 0.3)'};

  svg {
    font-size: 16px;
    flex-shrink: 0;
    color: ${(props) => (props.$severity === 'quebra' ? '#ef4444' : (props.theme.name === 'light' ? '#d97706' : '#f59e0b'))};
  }
`

export const MultiUfContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 14px;
`

export const UfSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  padding-bottom: 6px;
  border-bottom: 1px solid ${(props) => (props.theme.name === 'light' ? '#e2e8f0' : 'rgba(255, 255, 255, 0.08)')};

  .section-title {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .section-desc {
    font-size: 11px;
    color: ${(props) => (props.theme.name === 'light' ? '#64748b' : '#94a3b8')};
  }
`

// --- COMPONENTES DA ABA DE HISTÓRICO DE PDVS & JUSTIFICATIVAS ---

export const PdvStatusBadge = styled.span<{ $status: 'ativo' | 'inativo_perdido' }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.3px;
  background: ${(props) =>
    props.$status === 'ativo' ? 'rgba(34, 197, 94, 0.12)' : 'rgba(239, 68, 68, 0.12)'};
  color: ${(props) => (props.$status === 'ativo' ? '#4ade80' : '#f87171')};
  border: 1px solid
    ${(props) =>
      props.$status === 'ativo' ? 'rgba(34, 197, 94, 0.3)' : 'rgba(239, 68, 68, 0.3)'};

  .dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: ${(props) => (props.$status === 'ativo' ? '#22c55e' : '#ef4444')};
    box-shadow: 0 0 6px ${(props) => (props.$status === 'ativo' ? '#22c55e' : '#ef4444')};
  }
`

export const JustificativaBadge = styled.button<{ $justificado: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  background: ${(props) =>
    props.$justificado ? 'rgba(56, 189, 248, 0.12)' : 'rgba(245, 158, 11, 0.12)'};
  color: ${(props) => (props.$justificado ? '#38bdf8' : '#fbbf24')};
  border: 1px solid
    ${(props) =>
      props.$justificado ? 'rgba(56, 189, 248, 0.35)' : 'rgba(245, 158, 11, 0.35)'};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    filter: brightness(1.2);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px ${(props) => (props.$justificado ? 'rgba(56, 189, 248, 0.2)' : 'rgba(245, 158, 11, 0.2)')};
  }
`

export const FilterChipGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`

export const FilterChip = styled.button<{ $active: boolean; $variant?: 'danger' | 'success' | 'warning' | 'info' | 'default' }>`
  background: ${(props) => {
    if (!props.$active) return 'rgba(255, 255, 255, 0.04)'
    switch (props.$variant) {
      case 'danger':
        return 'rgba(239, 68, 68, 0.22)'
      case 'success':
        return 'rgba(34, 197, 94, 0.22)'
      case 'warning':
        return 'rgba(245, 158, 11, 0.22)'
      case 'info':
        return 'rgba(56, 189, 248, 0.22)'
      default:
        return 'rgba(37, 99, 235, 0.3)'
    }
  }};
  border: 1px solid
    ${(props) => {
      if (!props.$active) return 'rgba(255, 255, 255, 0.09)'
      switch (props.$variant) {
        case 'danger':
          return '#ef4444'
        case 'success':
          return '#22c55e'
        case 'warning':
          return '#f59e0b'
        case 'info':
          return '#38bdf8'
        default:
          return '#3b82f6'
      }
    }};
  color: ${(props) => {
    if (!props.$active) return '#94a3b8'
    switch (props.$variant) {
      case 'danger':
        return '#fca5a5'
      case 'success':
        return '#86efac'
      case 'warning':
        return '#fde68a'
      case 'info':
        return '#7dd3fc'
      default:
        return '#ffffff'
    }
  }};
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  box-shadow: ${(props) => (props.$active ? '0 2px 8px rgba(0, 0, 0, 0.3)' : 'none')};

  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #ffffff;
  }
`

export const PaginationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(0, 0, 0, 0.2);
  flex-wrap: wrap;
  gap: 12px;

  .page-info {
    font-size: 12px;
    color: #94a3b8;
  }

  .btn-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }
`

// --- MODAL DE JUSTIFICATIVA & CLIENTES ---

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.78);
  backdrop-filter: blur(8px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`

export const ModalContent = styled.div`
  background: #111827;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 14px;
  width: 100%;
  max-width: 520px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.25s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(16px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const ClientsModalContent = styled.div`
  background: linear-gradient(180deg, #0d1527 0%, #080c18 100%);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 16px;
  width: 95vw;
  max-width: 1420px;
  height: 90vh;
  box-shadow: 0 25px 60px -15px rgba(0, 0, 0, 0.85), 0 0 0 1px rgba(255, 255, 255, 0.05);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.25s ease-out;

  @keyframes slideUp {
    from {
      transform: translateY(16px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const ModalTableScroll = styled.div`
  flex: 1;
  overflow-y: auto;
  overflow-x: auto;
  padding: 0 24px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(15, 23, 42, 0.6);
    border-radius: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #334155;
    border-radius: 4px;
    transition: background 0.2s;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: #64748b;
  }
`

export const ModalClientsTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 13px;

  thead th {
    position: sticky;
    top: 0;
    background: #0d1527;
    color: #94a3b8;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    padding: 14px 16px;
    border-bottom: 2px solid rgba(255, 255, 255, 0.1);
    z-index: 2;
    white-space: nowrap;
  }

  tbody tr {
    transition: background 0.15s ease;
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);

    &:hover {
      background: rgba(56, 189, 248, 0.06);
    }
  }

  tbody td {
    padding: 13px 16px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);
    color: #e2e8f0;
    vertical-align: middle;
  }
`

export const ModalStatsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
`

export const ModalStatPill = styled.div<{ $variant?: 'neutral' | 'success' | 'danger' }>`
  background: ${(props) => {
    switch (props.$variant) {
      case 'success':
        return 'rgba(34, 197, 94, 0.08)'
      case 'danger':
        return 'rgba(239, 68, 68, 0.08)'
      default:
        return 'rgba(255, 255, 255, 0.04)'
    }
  }};
  border: 1px solid ${(props) => {
    switch (props.$variant) {
      case 'success':
        return 'rgba(34, 197, 94, 0.25)'
      case 'danger':
        return 'rgba(239, 68, 68, 0.25)'
      default:
        return 'rgba(255, 255, 255, 0.1)'
    }
  }};
  border-radius: 10px;
  padding: 8px 16px;
  display: flex;
  flex-direction: column;
  gap: 2px;

  .stat-label {
    font-size: 11px;
    color: #94a3b8;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    font-weight: 600;
  }

  .stat-value {
    font-size: 16px;
    font-weight: 700;
    color: ${(props) => {
      switch (props.$variant) {
        case 'success':
          return '#4ade80'
        case 'danger':
          return '#f87171'
        default:
          return '#ffffff'
      }
    }};
  }
`

export const ModalHeader = styled.div`
  padding: 16px 20px;
  background: rgba(255, 255, 255, 0.03);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;

  h3 {
    font-size: 15px;
    font-weight: 700;
    color: #fff;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;

    svg {
      color: #a6c10b;
    }
  }

  button.close-btn {
    background: transparent;
    border: none;
    color: #94a3b8;
    font-size: 18px;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;

    &:hover {
      color: #f87171;
    }
  }
`

export const ModalBody = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;

  .pdv-info-card {
    background: rgba(255, 255, 255, 0.04);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    padding: 12px;

    .pdv-name {
      font-weight: 700;
      color: #f8fafc;
      font-size: 13px;
      margin-bottom: 4px;
    }

    .pdv-details {
      font-size: 11px;
      color: #94a3b8;
      display: flex;
      gap: 12px;
      flex-wrap: wrap;
    }
  }
`

export const FormLabel = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #e2e8f0;
  margin-bottom: 6px;
`

export const StyledSelect = styled.select`
  width: 100%;
  background: #1f2937;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 10px 14px;
  color: #fff;
  font-size: 13px;
  outline: none;
  transition: border-color 0.2s;

  &:focus {
    border-color: #a6c10b;
  }

  option {
    background: #111827;
    color: #fff;
  }
`

export const StyledTextArea = styled.textarea`
  width: 100%;
  background: #1f2937;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  padding: 10px 14px;
  color: #fff;
  font-size: 13px;
  outline: none;
  min-height: 90px;
  resize: vertical;
  transition: border-color 0.2s;

  &:focus {
    border-color: #a6c10b;
  }

  &::placeholder {
    color: #64748b;
  }
`

export const ModalFooter = styled.div`
  padding: 14px 20px;
  background: rgba(255, 255, 255, 0.02);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;

  button.btn-cancel {
    background: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: #cbd5e1;
    padding: 8px 16px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;

    &:hover {
      background: rgba(255, 255, 255, 0.15);
      color: #fff;
    }
  }

  button.btn-save {
    background: #a6c10b;
    border: 1px solid #a6c10b;
    color: #0f172a;
    padding: 8px 18px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    &:not(:disabled):hover {
      background: #b7d413;
      transform: translateY(-1px);
    }
  }
`

export const BatchActionBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  background: rgba(166, 193, 11, 0.12);
  border: 1px solid rgba(166, 193, 11, 0.35);
  border-radius: 8px;
  padding: 10px 16px;
  animation: fadeIn 0.2s ease-in-out;

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-4px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .batch-info {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 13px;
    font-weight: 600;
    color: #f8fafc;

    svg {
      color: #a6c10b;
      font-size: 16px;
    }

    .badge-count {
      background: #a6c10b;
      color: #0f172a;
      font-weight: 800;
      padding: 2px 8px;
      border-radius: 12px;
      font-size: 12px;
    }
  }

  .batch-actions {
    display: flex;
    align-items: center;
    gap: 10px;

    button.btn-batch-action {
      background: #a6c10b;
      border: 1px solid #a6c10b;
      color: #0f172a;
      font-size: 12px;
      font-weight: 700;
      padding: 6px 14px;
      border-radius: 6px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 6px;
      transition: all 0.2s;

      &:hover {
        background: #b7d413;
        transform: translateY(-1px);
      }
    }

    button.btn-clear {
      background: transparent;
      border: 1px solid rgba(255, 255, 255, 0.15);
      color: #94a3b8;
      font-size: 12px;
      font-weight: 600;
      padding: 6px 12px;
      border-radius: 6px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
      gap: 4px;
      transition: all 0.2s;

      &:hover {
        color: #fff;
        background: rgba(255, 255, 255, 0.08);
      }
    }
  }
`


